export default __webpack_public_path__ + "static/media/illustration-work-3-m@2x.e0bd4dad.webp";